import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./component/Header";
import Main from "./pages/Main";
import Footer from "./component/Footer";

const App = () => {
  return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
  );
};

export default App;
